
  export default {
    props: {
      color: {
        type: String,
        default: '#1A1A1A'
      }
    }
  }
